import MobileBottomNav from "./MobileBottomNav";

export { MobileBottomNav as default };
